<template>
  <v-dialog v-model="dialog" persistent max-width="490">
    <v-card class="px-2 py-2">
      <v-card-title class="px-4 text-h5" style="color: #02a554">
        Consulta agendada com sucesso!
      </v-card-title>
      <div class="d-flex align-center">
        <p class="text-left color-darkGray px-4 py-6" style="font-size: 18px">
          Sua consulta só será realizada após a compensação do pagamento.
        </p>
      </div>
      <v-card-text class="d-flex">
        <div class="d-flex flex-column align-center justify-center card-bord">
          <div class="container-clipBoard">
            <div>
              <p style="margin: 0; font-size: 16px; color: #6f6f6f">
                Código para Pagamento Multibanco
              </p>
              <div class="d-flex justify-space-around">
                <p style="margin: 0" class="font-weight-bold color-darkGray mr-2">
                  Entidade: {{ entity }}
                </p>
                <p style="margin: 0" class="font-weight-bold color-darkGray">
                  Referência: {{ reference }}
                </p>
              </div>
            </div>
            <div @click="copy" class="ml-10" style="cursor: pointer">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="28.5"
                height="33"
                viewBox="0 0 28.5 33"
              >
                <path
                  id="Icon_material-content-copy"
                  data-name="Icon material-content-copy"
                  d="M24,1.5H6a3.009,3.009,0,0,0-3,3v21H6V4.5H24Zm4.5,6H12a3.009,3.009,0,0,0-3,3v21a3.009,3.009,0,0,0,3,3H28.5a3.009,3.009,0,0,0,3-3v-21A3.009,3.009,0,0,0,28.5,7.5Zm0,24H12v-21H28.5Z"
                  transform="translate(-3 -1.5)"
                  fill="#6f6f6f"
                />
              </svg>
            </div>
          </div>
        </div>
      </v-card-text>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn color="green darken-1" text @click="ok"> Ok </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  props: {
    entity: { type: String },
    reference: { type: String },
  },
  data() {
    return {
      dialog: false,
      link: null,
    };
  },
  methods: {
    openDialog(param = {}) {
      this.link = param.link;
      this.dialog = true;
    },
    ok() {
      this.dialog = false;
      this.$emit('ok');
    },
    copy() {
      this.$emit('copy');
    },
  },
};
</script>

<style scoped>
.card-bord {
  border: 1px solid #707070;
  width: 400px;
  border-radius: 8px;
  padding: 6px;
}
.container-clipBoard {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 6px;
}
</style>
